import styled from 'styled-components';

import {
  Button,
  TextInput,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

export const Input = styled(TextInput)`
  position: relative;
`;

export const Placeholder = styled.span`
  position: absolute;
  color: #808080;
  font-size: 16px;
  left: 0;
  top: 0;
`;

export const FieldWrapper = styled(Flex).attrs<{ couponStatus?: string }>({
  column: true,
  flex: '1 1 100%',
  spacing: 5,
})`
  position: relative;

  ${props => props.couponStatus === 'invalid' && `
    input {
      border-color: #FF0404;
    }
  `}

  .error-msg {
    color: #FF0404;
    font-size: 16px;
  }

  & + button {
    position: relative;
    top: 1.7rem;
    left: 0;
  }
`;

export const Submit = styled(Button).attrs({
  type: 'button',
  appearance: 'primary',
})`
  font-size: 16px;
  display: block;
  padding: 8px 29px;

  ${props => props.isDisabled && `
    opacity: 0.55;
  `}
`;
